import { Linkedin, Twitter, Users } from 'lucide-react';

const team = [
  {
    name: 'Alexandra Chen',
    role: 'CEO & Co-Founder',
    bio: 'Former Chief Compliance Officer at a top-10 commodity trading firm. 15+ years in derivatives compliance.',
    initials: 'AC',
    linkedin: '#',
    twitter: '#',
  },
  {
    name: 'Marcus Rodriguez',
    role: 'CTO & Co-Founder',
    bio: 'Built trading systems at Goldman Sachs and Jump Trading. MS in Computer Science from MIT.',
    initials: 'MR',
    linkedin: '#',
    twitter: '#',
  },
  {
    name: 'Jennifer Walsh',
    role: 'Chief Compliance Officer',
    bio: 'Former CFTC examiner with 12 years of regulatory experience. Expert in position limit rules.',
    initials: 'JW',
    linkedin: '#',
    twitter: '#',
  },
];

export function TeamSection() {
  return (
    <section id="team" className="relative py-20 md:py-28 bg-slate-50">
      <div className="container relative">
        {/* Section Header */}
        <div className="mx-auto max-w-2xl text-center mb-12">
          <div className="inline-flex items-center gap-2 rounded-full bg-slate-100 border border-slate-200 px-4 py-1.5 text-sm mb-6">
            <Users className="h-4 w-4 text-purple-600" />
            <span className="text-slate-700 font-medium">Our Team</span>
          </div>
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-4 text-slate-900">
            Built by{' '}
            <span className="text-purple-600">
              Compliance Experts
            </span>
          </h2>
          <p className="text-lg text-slate-600">
            Our team combines deep regulatory expertise with world-class technology skills.
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid gap-8 md:grid-cols-3 max-w-4xl mx-auto">
          {team.map((member) => (
            <div
              key={member.name}
              className="rounded-2xl bg-white border border-slate-200 p-6 text-center shadow-sm hover:shadow-md transition-shadow"
            >
              {/* Avatar */}
              <div className="relative mx-auto mb-4 w-24 h-24">
                <div className="absolute inset-0 rounded-full bg-purple-600 flex items-center justify-center">
                  <span className="text-2xl font-bold text-white">
                    {member.initials}
                  </span>
                </div>
              </div>

              {/* Info */}
              <h3 className="font-semibold text-lg text-slate-900">{member.name}</h3>
              <p className="text-sm text-purple-600 font-medium mb-3">{member.role}</p>
              <p className="text-sm text-slate-600 mb-4">{member.bio}</p>

              {/* Social Links */}
              <div className="flex justify-center gap-3">
                <a
                  href={member.linkedin}
                  className="p-2 rounded-lg bg-slate-100 hover:bg-purple-600 group/link transition-colors"
                  aria-label={`${member.name} on LinkedIn`}
                >
                  <Linkedin className="h-4 w-4 text-slate-500 group-hover/link:text-white transition-colors" />
                </a>
                <a
                  href={member.twitter}
                  className="p-2 rounded-lg bg-slate-100 hover:bg-purple-600 group/link transition-colors"
                  aria-label={`${member.name} on Twitter`}
                >
                  <Twitter className="h-4 w-4 text-slate-500 group-hover/link:text-white transition-colors" />
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Company Note */}
        <div className="mt-12 text-center max-w-2xl mx-auto">
          <p className="text-slate-600">
            PositionIQ was founded in 2023 with a mission to modernize commodity trading compliance.
            We're backed by leading fintech investors and advised by industry veterans.
          </p>
        </div>
      </div>
    </section>
  );
}
